var spinData = {
  name: 'spin',
  data: [{
    size: 50,
    type: 'circle',
    circleColorGradient: ['#87B4F5', '#4f7de7'],
    fillColor: 'rgba(0,0,0,0)'
  }]
};
export default spinData;